import React, { useEffect, useState } from "react";
import {
    doAProfessionalPayment,
    payWithPaypal,
    payWithStripe,
} from "../../services/client";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export default function PayOptionsPopUp({
    paymentInfo,
    session_id,
    subsession_id,
    medium_id,
    price,
    duration,
    bookingTime,
    bookingDate,
    setCounterStatus,
    createBooking
}) {
    const { t } = useTranslation("publicGuestBooking");

    ;

    const paymentMethodHandler = (type) => {
        let item = {

            paymenttype: type,
        };
        createBooking(item)

    }

    const openWaitingContainer = () => {
        setCounterStatus(true);
        window.loadModal2("#payoptionspopupguestBooking", "hide");
    };


    const checkPyamentType = (info, type) => {
        let status = false;

        if (type === "paypal") {

            if (info !== undefined &&
                info.is_paypal_integrated) {
                status = true;
            }
            else {
                status = false;
            }
        }


        if (type === "stripe") {
            if (info !== undefined &&
                info.is_stripe_integrated) {
                status = true;
            }
            else {
                status = false;
            }
        }


        if (type === "squareup") {

            if (info !== undefined &&
                info.is_squareup_integrated) {
                status = true;
            }
            else {
                status = false;
            }

        }
        return status;
    }
    return (
        <div
            className="modal fade"
            id="payoptionspopupguestBooking"
            role="dialog"
            data-backdrop="true"
        >
            <div className="modal-dialog modal-dialog-preview w-100">
                <div className="modal-content margin-top-300 border-waiting-time">
                    <div className="modal-body modal-body-waiting-time">
                        <button type="button" className="close" data-dismiss="modal">
                            &times;
                        </button>
                        <div className="profile-video"></div>
                        <h3 className="text-center mt-2">{t("payment.payWith")}</h3>
                        <div>
                            <div className="payment-new-wrapper mt-5">
                                <div className="payment-new-container mt-5">


                                    {checkPyamentType(paymentInfo, 'paypal') && (
                                        <button
                                            onClick={() => paymentMethodHandler("paypal")}
                                            data-toggle="modal"
                                            className={`main-btn`}
                                        >
                                            {" "}
                                            <img src={"/integrationimages/paypal.png"} />
                                        </button>
                                    )}
                                    {checkPyamentType(paymentInfo, 'stripe') &&
                                        <button
                                            onClick={() => paymentMethodHandler("stripe")}
                                            data-toggle="modal"
                                            className={`main-btn`}
                                        >
                                            {" "}
                                            <img
                                                className="stripe-img"
                                                src={"/integrationimages/stripe.png"}
                                            />
                                        </button>
                                    }
                                    {checkPyamentType(paymentInfo, 'squareup') && (
                                        <button
                                            onClick={() => paymentMethodHandler("squareup")}
                                            data-toggle="modal"
                                            className={`main-btn font-size-22`}
                                        >
                                            {" "}
                                            {/* Square */}
                                            <img
                                                className="stripe-square"
                                                src={"/integrationimages/square-black.jpg"}
                                            />
                                        </button>
                                    )}
                                </div>
                            </div>
                            {/* <PaymentPrices paymentMethodHandler={paymentMethodHandler} setPaymentAmount={setPaymentAmount} /> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
